export default __webpack_public_path__ + "static/media/coming-soon.4664120d.webp";